import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Avatar, Form, FormListFieldData } from 'antd';
import styled from 'styled-components';
import SwitchBookingOnline from './SwitchBookingOnline';
import { getStaffPositionLabel } from 'features/settingStaff/services/constants';

type Props = {
  id: string;
  name: string;
  type: string;
  avatar: string;
  field: FormListFieldData;
};

const ReoderBookingSortableItem = ({ id, name, type, avatar, field }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: id || '',
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Container>
        <div className='left-box'>
          <div className='icon-box'>{menu}</div>
          <div className='staff-box'>
            <Avatar size={50} src={avatar || undefined}>{name?.[0] || 'A'}</Avatar>
            <div className='details-box'>
              <div className='name'>{name}</div>
              <div className='role'>{getStaffPositionLabel(type as any)}</div>
            </div>
          </div>
        </div>
        <Form.Item name={[field.name, 'activeBooking']} noStyle>
          <SwitchBookingOnline />
        </Form.Item>
      </Container>
    </div>
  );
};

export default ReoderBookingSortableItem;

const Container = styled.div`
  width: 100%;
  display: flex;
  padding: 8px 16px;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #ccd4dc;
  background: #fff;
  .left-box {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    .icon-box {
      display: flex;
      padding: 4px;
      justify-content: center;
      align-items: center;
    }
    .staff-box {
      display: flex;
      align-items: center;
      gap: 8px;
      align-self: stretch;
      .details-box {
        display: flex;
        flex-direction: column;
        gap: 2px;
        .name {
          color: #1d2129;
          font-family: Poppins;
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        .role {
          color: #64748b;
          font-family: Poppins;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }
  }
`;

const menu = (
  <svg xmlns='http://www.w3.org/2000/svg' width='9' height='15' viewBox='0 0 9 15' fill='none'>
    <path
      d='M1.56162 11.4996C1.25748 11.4998 0.960223 11.5902 0.707452 11.7594C0.454682 11.9285 0.257747 12.1688 0.141551 12.4499C0.0253551 12.731 -0.00488311 13.0402 0.0546602 13.3385C0.114204 13.6367 0.260854 13.9106 0.476067 14.1256C0.69128 14.3405 0.965389 14.4867 1.26373 14.5459C1.56207 14.605 1.87125 14.5743 2.15216 14.4577C2.43308 14.3412 2.67311 14.1439 2.84191 13.8909C3.01071 13.6379 3.10069 13.3405 3.10048 13.0364C3.09963 12.6287 2.93716 12.238 2.64869 11.9499C2.36022 11.6618 1.96929 11.4999 1.56162 11.4996Z'
      fill='#ADADAD'
    />
    <path
      d='M6.67246 11.4996C6.36832 11.4998 6.07106 11.5902 5.81829 11.7594C5.56552 11.9285 5.36859 12.1688 5.25239 12.4499C5.13619 12.731 5.10596 13.0402 5.1655 13.3385C5.22504 13.6367 5.37169 13.9106 5.58691 14.1256C5.80212 14.3405 6.07623 14.4867 6.37457 14.5459C6.67291 14.605 6.98209 14.5743 7.263 14.4577C7.54392 14.3412 7.78395 14.1439 7.95275 13.8909C8.12155 13.6379 8.21153 13.3405 8.21132 13.0364C8.21047 12.6287 8.048 12.238 7.75953 11.9499C7.47106 11.6618 7.08013 11.4999 6.67246 11.4996Z'
      fill='#ADADAD'
    />
    <path
      d='M1.56168 5.76123C1.20624 5.76167 0.861944 5.88531 0.587426 6.11109C0.312909 6.33687 0.125147 6.65083 0.0561169 6.9995C-0.0129128 7.34817 0.0410591 7.70999 0.208841 8.02334C0.376622 8.33669 0.647838 8.58218 0.976297 8.71802C1.30476 8.85385 1.67015 8.87163 2.01024 8.76832C2.35033 8.665 2.6441 8.44699 2.8415 8.15141C3.03891 7.85583 3.12774 7.50096 3.09289 7.14724C3.05803 6.79351 2.90163 6.46281 2.65032 6.21144C2.36146 5.92301 1.96989 5.76108 1.56168 5.76123Z'
      fill='#ADADAD'
    />
    <path
      d='M6.67057 5.76123C6.31513 5.76167 5.97083 5.88531 5.69631 6.11109C5.4218 6.33687 5.23403 6.65083 5.165 6.9995C5.09597 7.34817 5.14995 7.70999 5.31773 8.02334C5.48551 8.33669 5.75672 8.58218 6.08518 8.71802C6.41364 8.85385 6.77903 8.87163 7.11913 8.76832C7.45922 8.665 7.75298 8.44699 7.95039 8.15141C8.14779 7.85583 8.23663 7.50096 8.20177 7.14724C8.16691 6.79351 8.01051 6.46281 7.75921 6.21144C7.47034 5.92301 7.07878 5.76108 6.67057 5.76123Z'
      fill='#ADADAD'
    />
    <path
      d='M1.56127 0.0229492C1.15328 0.0229492 0.762005 0.185022 0.473513 0.473513C0.185022 0.762004 0.0229492 1.15328 0.0229492 1.56127C0.0229492 1.96926 0.185022 2.36054 0.473513 2.64903C0.762005 2.93752 1.15328 3.09959 1.56127 3.09959C1.96926 3.09959 2.36054 2.93752 2.64903 2.64903C2.93752 2.36054 3.09959 1.96926 3.09959 1.56127C3.09959 1.15328 2.93752 0.762004 2.64903 0.473513C2.36054 0.185022 1.96926 0.0229492 1.56127 0.0229492Z'
      fill='#ADADAD'
    />
    <path
      d='M6.67406 0.0229492C6.26608 0.0229492 5.8748 0.185022 5.58631 0.473513C5.29781 0.762004 5.13574 1.15328 5.13574 1.56127C5.13574 1.96926 5.29781 2.36054 5.58631 2.64903C5.8748 2.93752 6.26608 3.09959 6.67406 3.09959C7.08205 3.09959 7.47333 2.93752 7.76182 2.64903C8.05031 2.36054 8.21239 1.96926 8.21239 1.56127C8.21239 1.15328 8.05031 0.762004 7.76182 0.473513C7.47333 0.185022 7.08205 0.0229492 6.67406 0.0229492Z'
      fill='#ADADAD'
    />
  </svg>
);
